import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {itsWarehouseAddressesModelFactory, ItsmWarehouseListResponse} from "./itsm-warehouse.model";

const DEFAULT_PAGE = "1";
const DEFAULT_PAGE_LIMIT = "10";

@Injectable({providedIn: "root"})
export class WarehouseService {
  private url: string = "/api/warehouses";

  async getWarehousesFromItsm(
    pageNumber = DEFAULT_PAGE,
    pageLength = DEFAULT_PAGE_LIMIT,
    searchText = "",
  ): Promise<ItsmWarehouseListResponse> {
    const params = {pageNumber, pageLength, searchText};
    return this.http.get(this.url, {params})
      .pipe(map(json => itsWarehouseAddressesModelFactory(json["result"])))
      .toPromise();
  }

  constructor(private http: HttpClient) {}
}
